console.log("Tabletop Goodies - Script - Colors");

TTG = function (parent) {
    const result = {};


    const _normalize = (value) => 
      {
        return value.toLowerCase().replaceAll(" ", "_");;
      }
  
  
    const _rgbColorClass = class {

        constructor(r, g, b, a) {
            this.r = Number(r);
            this.g = Number(g);
            this.b = Number(b);
            if (TTG.isNullOrWhiteSpaces(a)){
                this.a = 255;
            }
            else {
                this.a = Number(a);
            }
        }

        toHEXString() {
            return "#" + (1 << 24 | this.r << 16 | this.g << 8 | this.b).toString(16).slice(1);
        }

        toRGBString() {
            return "rgb(" + this.r + "," + this.g + "," + this.b + ")";
        }

        toRGBAString() {
            return "rgba(" + this.r + "," + this.g + "," + this.b + "," + this.a + ")";
        }

        isLight() {
            return (1 - (0.299 * this.r + 0.587 * this.g + 0.114 * this.b) / 255) < 0.5;
        }


      

    }

    // Always return a RGB color, we can then convert if needed
    const _parse = (value) => {
        let m = value.match(/^#([0-9a-f]{3})$/i);
        if (m) {
            // in three-character format, each value is multiplied by 0x11 to give an
            // even scale from 0x00 to 0xff
            return new _rgbColorClass(
                parseInt(m.charAt(0), 16) * 0x11,
                parseInt(m.charAt(1), 16) * 0x11,
                parseInt(m.charAt(2), 16) * 0x11,
                255);
        }
        else {
            m = value.match(/^#([0-9a-f]{8})$/i);
            if (m) {
                return new _rgbColorClass(
                    parseInt(m[1].substr(0, 2), 16),
                    parseInt(m[1].substr(2, 2), 16),
                    parseInt(m[1].substr(4, 2), 16),
                    parseInt(m[1].substr(6, 2), 16));
            }
            else {
                m = value.match(/^#([0-9a-f]{6})$/i);
                if (m) {
                    return new _rgbColorClass(
                        parseInt(m[1].substr(0, 2), 16),
                        parseInt(m[1].substr(2, 2), 16),
                        parseInt(m[1].substr(4, 2), 16),
                        255);
                }
                else {
                    m = value.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
                    if (m) {
                        return new _rgbColorClass(
                            m[1],
                            m[2],
                            m[3],
                            255);
                    }
                    else {
                        throw "Cannot parse RGB color: " + value;
                    }
                }
            }

        }
    }
    result.parse = _parse;
    result.normalize = _normalize;
    result.RGBColor = _rgbColorClass;
    parent.Colors = result;
    return parent;
}(TTG);
